import {
  OrganizationType,
  type PersonSportRankingResponse,
  type RelatedRankingResponse,
} from '@on3/api';
import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { Fragment } from 'react';

import { PlayerRankingsItem } from '../PlayerRankingsItem';
import styles from './PlayerRankingsList.module.scss';

interface IPlayerRankingListProps {
  playerList: PersonSportRankingResponse[];
  relatedModel?: RelatedRankingResponse;
}
const adsPlacement = [
  10, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375,
  400, 425, 450, 475, 500, 525, 550, 575,
];

export const PlayerRankingList = ({
  playerList,
  relatedModel,
}: IPlayerRankingListProps) => {
  const isCollege =
    relatedModel?.ranking?.organizationType === OrganizationType.College;

  return (
    <>
      <div
        className={styles.block}
        data-ranking-type={relatedModel?.ranking?.organizationType.toLowerCase()}
        role="row"
      >
        <div data-name="rank" id="rank" role="columnheader">
          Rank
        </div>
        <div
          className={styles.player}
          data-name="player"
          id="player"
          role="columnheader"
        >
          Player
        </div>
        <div data-name="position" id="position" role="columnheader">
          Pos
        </div>
        {isCollege && (
          <>
            <div data-name="class" id="class" role="columnheader">
              Class
            </div>
            <div data-name="age" id="age" role="columnheader">
              Age
            </div>
          </>
        )}
        <div data-name="nil" id="nil" role="columnheader">
          NIL
        </div>
        <div data-name="rating" id="rating" role="columnheader">
          Rating
        </div>
        {!isCollege && (
          <div data-name="status" id="status" role="columnheader">
            Status
          </div>
        )}
        <div
          data-name="athlete-verified"
          id="athlete-verified"
          role="columnheader"
        >
          Athlete-Verified
        </div>
      </div>

      {playerList.map((player, index) => (
        <Fragment key={player.key}>
          {adsPlacement.includes(index) && (
            <div className={styles.ad} role="row">
              <MobileMPU
                id={`mobile_mpu_inc-${adsPlacement.indexOf(index) + 1}`}
                incontent
              />
            </div>
          )}
          <PlayerRankingsItem player={player} relatedModel={relatedModel} />
        </Fragment>
      ))}
    </>
  );
};
